import { axiosInstance } from "../";

export const communities = {
	get: (payload: any) =>
		axiosInstance().get("/communities", { params: payload }),
};
